import Vue from 'vue';
import Vuex from 'vuex';

import moduleProfile from './profile';
import moduleAutodesk from './autodesk';
import moduleServices from './services';
import moduleViewer from './viewer';
import moduleProjectCreator from './project-creator';
import moduleProjectAdministration from './project-administration';
import moduleTririga from './tririga';
import moduleCfaDynamoData from './cfa-dynamo-data';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    downloads: [],
    showDownloads: false,
    dialogShowHelp: false,
    expandDownloads: false,
    isOpenApplicationList: false,
  },
  mutations: {
    openApplicationList(state, isOpenApplicationList) {
      state.isOpenApplicationList = isOpenApplicationList;
    },
    setShowDownloads(state, value) {
      state.showDownloads = value;
    },
    setExpandDownloads(state, value) {
      state.expandDownloads = value;
    },
    addDownload(state, file) {
      state.downloads.push(file);
    },
    updateDownload(state, data) {
      const index = state.downloads.findIndex(file => file.name === data.name && file.status === 'progress');
      Vue.set(state.downloads, index, data);
    },
    setDialogShowHelp(state, value) {
      state.dialogShowHelp = value;
    },
  },
  actions: {
  },
  modules: {
    profile: moduleProfile,
    viewer: moduleViewer,
    projectCreator: moduleProjectCreator,
    projectAdministration: moduleProjectAdministration,
    autodesk: moduleAutodesk,
    service: moduleServices,
    tririga: moduleTririga,
    cfaDynamoData: moduleCfaDynamoData,
  },
});
